import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";

const root = document.getElementById("root");
if (root === null) {
  throw new Error("No root element found");
}

Sentry.init({
  dsn: "https://dcbccd2e8a512d42eb90e7e599a00933@o4509271752704000.ingest.us.sentry.io/4509271757619200"
});

ReactDOM.createRoot(root).render(<App />);
